export const iconFontAwesomeSpinnersCircleNotch = (
	<i className="fa-solid fa-circle-notch"></i>
);
